<template>
  <cx-showcase-section :name="name" :link="link" class="cx-input-showcase">
    <div class="cx-input-showcase__content">
      <div class="cx-input-showcase__element">
        <cx-input
          :label="'Normal input'"
          v-model="someValue"
          placeholder="Normal input"
          tooltip="Normal input tooltip"
          appendIcon="brightness_1">
        </cx-input>
      </div>
      <div class="cx-input-showcase__element">
        <cx-input
          :label="'Loading input'"
          :modelValue="someValue"
          placeholder="Loading input"
          tooltip="Loading input tooltip"
          appendIcon="brightness_1"
          :loading="true">
        </cx-input>
      </div>
      <div class="cx-input-showcase__element">
        <cx-input
          :label="'Disabled input'"
          :modelValue="someValueDisabled"
          placeholder="Disabled input"
          tooltip="Disabled input tooltip"
          appendIcon="brightness_1"
          :disabled="true">
        </cx-input>
      </div>
    </div>
  </cx-showcase-section>
</template>

<script>
import CxInput from '../../CxInput.vue';
import CxShowcaseSection from '../CxShowcaseSection';

export default {
  name: 'CxInputShowcase',
  components: {
    CxShowcaseSection,
    CxInput,
  },
  data() {
    return {
      name: 'CxInput',
      link: '',
      someValue: '',
      someValueDisabled: ''
    };
  },
};

</script>

<style lang="less">
@import '../../../common';

.cx-input-showcase__content {
    display: flex;
    gap: 10px;
    .cx-input-showcase__element {
        display: flex;
        flex-direction: column;
        width: 400px;
    }
}
</style>